export default {
  title_one: 'Jednorazowe użycie, {{discount}}',
  title_few: '{{count}} użycia, {{discount}}',
  title_many: '{{count}} użyć, {{discount}}',
  title_other: '{{count}} użyć, {{discount}}',
  labels: {
    fixed_discount: '{{discount}} łączny rabat',
    percentage_discount: 'Rabat procentowy',
  },
  buttons: {
    add_component: 'Dodaj użycie',
  },
};
